import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {Button, message} from 'antd';

import { popupPaymentStore } from "../../../actions/optionsStoreActions";
import { postCreateStripeLink, postCreateStripeConnectAccount, getConnectedAccountInfo } from "../../../services/firebase/firebase";

import './paymentTab.less'

const Payments = ({ userData, card, user, popupPaymentStore }) => {
  const [ accountInfoState, setAccountInfoState] = useState({});
  const [ isLoading, setLoading] = useState(false);
  const [ stripeAccountIdState, setStripeAccountId] = useState(null);
  const { Email, stripeAccountId } = userData;

  useEffect(
    () => {
      setStripeAccountId(stripeAccountId);

      getConnectedAccountInfo(stripeAccountId)
        .then((account) => {
          if (account && account.accountInfo && account.accountInfo.individual) {
            setAccountInfoState(account.accountInfo.individual)
          }

          message.success('Got actual Stripe info.');
        })
        .catch(() => message.error("Can't connect to Stripe server. Please try later."))
    },
    [stripeAccountId],
  );

  const handleCreateStripeLink = () => {
    stripeAccountIdState && postCreateStripeLink(stripeAccountIdState)
      .then((linkObject) => {
        if (linkObject) {
          const win = window.open(linkObject.link.url, '_blank');
          win.focus();
        } else {
          return message.error('Problems with getting link');
        }
      })
  };

  const handleCreateStripeConnectAccount = () => {
    if (user) {

      setLoading(true);
      postCreateStripeConnectAccount(Email, user.uid)
        .then((stripeAccount) => {
          setLoading(false);
          setStripeAccountId(stripeAccount.succeeded.id);

          message.success('Stripe account created.');
        })
        .catch(error => message.error(`Error ${error}`))
    }
  };

  const { verification, first_name, last_name } = accountInfoState;
  const isHaveCard = !!(card && card.id);
  const isVerified = verification && verification.status === "verified";

  return (
    <div className="payments-wr">
      <div className="account-info">
        <h2>Stripe account:</h2>

        {
          verification ? (
            <div>
              <p>
                <span>First Name:</span> {first_name}
              </p>

              <p>
                <span>Last Name:</span> {last_name}
              </p>

              {
                verification.status === "verified" && (
                  <div className="verification-wrapper success">
                    <p>Your Stripe account has been verified.</p>
                  </div>
                )
              }

              {
                verification.status === "pending" && (
                  <div className="verification-wrapper pending">
                    <p>Stripe support team reviewing your data.</p>
                  </div>
                )
              }

              {
                verification.status === "unverified" && (
                  <div className="verification-wrapper unverified">
                    <p>Stripe needs some more info to verify your account. Click below to finish.</p>
                  </div>
                )
              }
            </div>
          ) : (
            "Please start verification process for getting payouts."
          )
        }
      </div>

      <div className="stripe-buttons-group">
        {
          (stripeAccountIdState && !isVerified) && (
            <Button
              className="stripe-button"
              onClick={handleCreateStripeLink}
            >
              Verify Stripe Account
            </Button>
          )
        }

        {
          (stripeAccountIdState && isVerified) && (
            <Button
              className="stripe-button"
              onClick={handleCreateStripeLink}
            >
              Update Stripe Account
            </Button>
          )
        }

        {
          !stripeAccountIdState && (
            <Button
              className={`stripe-button ${isLoading ? 'disabled' : '' }`}
              onClick={handleCreateStripeConnectAccount}
              disabled={!user || isLoading}
            >
              Create Stripe Account
            </Button>
          )
        }
      </div>

      <h2>Card information:</h2>

      {
        card ? (
          <div>
            <p>
              <span>Country:</span> {card.country}
            </p>

            <p>
              <span>Brand:</span> {card.brand}
            </p>

            <p>
              <span>Last 4:</span> **** {card.last4}
            </p>
          </div>
        ) : (
          <p>After verification you can add a debit card for payouts.</p>
        )
      }


      <div className="stripe-buttons-group">
        {
          stripeAccountIdState && (
            <Button
              className={`stripe-button ${(!isVerified || isHaveCard) ? 'disabled' : '' }`}
              onClick={() => popupPaymentStore('addCard')}
              type="primary"
              disabled={isHaveCard}
            >
              Add card
            </Button>
          )
        }
      </div>
    </div>
  );
};

export default connect(null, { popupPaymentStore })(Payments);



// WEBPACK FOOTER //
// ./src/pages/MyProfile/PaymentsTab/index.js